import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { updateAuth } from '../store/auth/auth.actions';
import { selectAuth } from '../store/auth/auth.selector';
import { TokenAuthState } from '../store/auth/auth.state';
import {
  getTokenFromStorage,
  saveTokenToStorage,
} from '../utility/common-logic';
import { HttpService } from './api-services/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SecondaryOtpService {
  private otpVerified: boolean = false;
  auth$: TokenAuthState;
  secondaryOtpEnabled = environment?.settings?.secondaryOtpEnabled;
  constructor(
    private httpService: HttpService,
    private store: Store,
  ) {
    const flag = localStorage.getItem('secondary_otp_verified');
    this.otpVerified = flag === 'true';

    this.store.pipe(select(selectAuth)).subscribe((auth) => {
      this.auth$ = auth;
    });
  }

  get isOtpVerified(): boolean {
    return this.otpVerified && !!getTokenFromStorage();
  }

  async requestSecondaryOtp(): Promise<any> {
    try {
      const res = await this.httpService.post(
        'profiles/api/generate-secondary-otp/',
        {},
      );
      return res && res.data !== undefined ? res.data : res;
    } catch (err: any) {
      throw err?.response?.data ?? err;
    }
  }

  async verifyOtp(otp: string, userId: number): Promise<any> {
    const payload = {
      user_id: userId,
      otp: otp,
    };
    try {
      const res = await this.httpService.post(
        'profiles/api/verify-secondary-otp/',
        payload,
      );
      return res && res.data !== undefined ? res.data : res;
    } catch (err: any) {
      throw err?.response?.data ?? err;
    }
  }

  markOtpVerified(token: string) {
    if (this.secondaryOtpEnabled) {
      this.otpVerified = true;
      localStorage.setItem('secondary_otp_verified', 'true');
    }
    saveTokenToStorage(token);
    this.store.dispatch(
      updateAuth({
        payload: {
          auth: {
            token: token,
          },
        },
      }),
    );
  }

  resetOtpVerification() {
    this.otpVerified = false;
  }
}
